import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useQuery } from "src/Hooks/useReactQuery";
import { getTestPackageDetail } from "src/services/test-packages";
import APP_ROUTES from "src/routes/routes";

const useGetTestPackageDetail = (id) => {
  const navigate = usePatchedNavigate();

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["test-package-detail", id],
    queryFn: () => getTestPackageDetail(id),
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
    cacheTime: 0,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    refetch,
    isLoading,
    isError,
    error,
  };
};

export default useGetTestPackageDetail;
